import { Alert } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { MissingField } from "../types/compose.types.ts"

export const MissingFields = ({ fields }: { fields?: MissingField[] }) => {
  const { t } = useTranslation()
  if (!fields?.length) return null
  return (
    <Alert
      type="warning"
      showIcon
      className="mb-3"
      message={t("communication.composer.missing", {
        fields: fields.map((field) => field.label).join(", ")
      })}
    />
  )
}
